import { parseISO, format, fromUnixTime } from 'date-fns';
import ipRegex from 'ip-regex';
import { parsePhoneNumber } from 'libphonenumber-js';
import urlRegex from 'url-regex';
var AWSDateFormatString = 'yyyy-MM-dd'; // date-fns format

var AWSTimeFormatString = "hh:mm:ss.SSSXXXXX"; // from docs: YYYY-MM-DDThh:mm:ss.sssZ

var AWSDateTimeFormatString = AWSDateFormatString + "'T'" + AWSTimeFormatString; // date-fns format

/**
 * Returns a Date parsed from the AppSync DateTime scalar
 * @param {string} date AWSDateTime returned from AppSync
 */

var parseAWSDateTime = function parseAWSDateTime(date) {
  return parseISO(date);
};
/**
 * Returns a Date parsed from the AppSync Date scalar
 * @param {string} date -  parse AWSDate returned from AppSync
 */


var parseAWSDate = function parseAWSDate(date) {
  return parseISO(date);
};
/**
 * Returns a string that can be passed to a GraphQL mutation as an AWSDateTime scalar
 * @param {Date|number|string} date - Date to be formatted
 */


var formatAWSDateTime = function formatAWSDateTime(date) {
  return format(new Date(date), AWSDateTimeFormatString);
};
/**
 * Returns a string that can be passed to a GraphQL mutation as an AWSDate scalar
 * @param date Used to construct a Date
 */


var formatAWSDate = function formatAWSDate(date) {
  return format(new Date(date), AWSDateFormatString);
};
/**
 *
 * @param timestamp Unix epoch timestamp
 */


var formatAWSTimestamp = function formatAWSTimestamp(timestamp) {
  return format(fromUnixTime(timestamp), AWSDateTimeFormatString);
}; // eslint-disable-next-line no-useless-escape


var AWSEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
/**
 * Returns true if the email an be used as AWSEmail scalar
 * @param {string} email
 */

var validateAWSEmail = function validateAWSEmail(email) {
  return AWSEmailRegex.test(email);
};

var validateAWSIPAddress = function validateAWSIPAddress(ip) {
  return ipRegex().test(ip);
};

var validateAWSPhone = function validateAWSPhone(phoneNumber, countryCode) {
  if (countryCode === void 0) {
    countryCode = 'US';
  }

  return parsePhoneNumber(phoneNumber, countryCode).isPossible();
};

var formatAWSPhone = function formatAWSPhone(phoneNumber, countryCode) {
  if (countryCode === void 0) {
    countryCode = 'US';
  }

  return parsePhoneNumber(phoneNumber, countryCode).formatInternational().replace(/\s/g, '');
};

var AWSURLRegex = /*#__PURE__*/urlRegex();

var validateAWSURL = function validateAWSURL(url) {
  return urlRegex().test(url);
};

export { AWSDateFormatString, AWSDateTimeFormatString, AWSEmailRegex, AWSTimeFormatString, AWSURLRegex, formatAWSDate, formatAWSDateTime, formatAWSPhone, formatAWSTimestamp, parseAWSDate, parseAWSDateTime, validateAWSEmail, validateAWSIPAddress, validateAWSPhone, validateAWSURL };